import { fetchUtils } from "react-admin";
export const httpClient= (url, options = {}) => {
  if (!options.headers) {
    options.headers = new Headers({ Accept: "application/json" ,'x-deviceType':'panel'});
  }
  const token = localStorage.getItem("Authorization");
  options.headers.set("Authorization", `${token}`);
  return fetchUtils.fetchJson(url, options);
};
